module.exports = __webpack_public_path__ + "img/conteudo-indiposnivel-universidade-2.8f672f5a.png";